export default __webpack_public_path__ + "static/media/aus-flag.d1f78538.png";